import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { resetPasswordService } from "../../services/authService";
import Logo from "../../assets/Images/logo.svg";

const EyeIcon = ({ open }) =>
  open ? (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  ) : (
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  );

const Spinner = () => (
  <svg style={{ width:15, height:15, animation:"spin 1s linear infinite" }} fill="none" viewBox="0 0 24 24">
    <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    <circle style={{ opacity:0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path style={{ opacity:0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
  </svg>
);

const inp = {
  width:"100%", border:"2px solid #f3f4f6", borderRadius:10,
  padding:"10px 40px 10px 14px", fontSize:13, color:"#111827",
  background:"#f9fafb", outline:"none", boxSizing:"border-box", fontFamily:"inherit",
};

const bg = { minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:24, position:"relative", overflow:"hidden", background:"linear-gradient(145deg,#161412 0%,#1f1b14 50%,#2a2319 100%)" };

const cardStyle = { position:"relative", zIndex:10, width:"100%", maxWidth:800, borderRadius:24, overflow:"hidden", display:"flex", boxShadow:"0 40px 120px rgba(0,0,0,0.65)", height:520 };

const leftStyle = { width:280, flexShrink:0, display:"flex", flexDirection:"column", justifyContent:"space-between", padding:32, position:"relative", overflow:"hidden", background:"linear-gradient(160deg,#1a1710 0%,#201d14 55%,#2e2718 100%)" };

const LeftPanel = ({ navigate }) => (
  <div style={leftStyle}>
    <div style={{ position:"absolute", width:200, height:200, borderRadius:"50%", background:"#FEBA06", opacity:0.1, top:-55, right:-55, filter:"blur(40px)", pointerEvents:"none" }} />
    <div style={{ position:"absolute", width:140, height:140, borderRadius:"50%", background:"#FEBA06", opacity:0.06, bottom:-35, left:-35, filter:"blur(32px)", pointerEvents:"none" }} />
    <div style={{ position:"absolute", width:120, height:120, borderRadius:"50%", border:"1px solid rgba(255,255,255,0.06)", top:"30%", right:-22, pointerEvents:"none" }} />

    <div style={{ position:"relative", zIndex:1 }}>
      <img src={Logo} alt="Paving Market" onClick={() => navigate("/")} style={{ height:30, width:"auto", cursor:"pointer", opacity:0.9 }} />
    </div>

    <div style={{ position:"relative", zIndex:1 }}>
      <div style={{ width:28, height:3, background:"#FEBA06", borderRadius:99, marginBottom:18 }} />
      <div style={{ fontSize:30, fontWeight:800, color:"#ffffff", lineHeight:1.15, letterSpacing:"-0.02em" }}>
        Set New<br />Password
      </div>
      <p style={{ fontSize:12, color:"#9ca3af", lineHeight:1.6, marginTop:10, maxWidth:200 }}>
        Choose a strong password to keep your account secure.
      </p>
      <div style={{ marginTop:24 }}>
        <p style={{ fontSize:11, color:"#4b5563", marginBottom:10 }}>Remember it?</p>
        <Link to="/login" style={{ display:"inline-flex", alignItems:"center", gap:8, border:"1px solid rgba(255,255,255,0.2)", color:"#ffffff", fontSize:12, fontWeight:600, padding:"9px 18px", borderRadius:10, textDecoration:"none" }}>
          Back to Sign in
          <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>

    <p style={{ position:"relative", zIndex:1, fontSize:10, color:"#374151" }}>© {new Date().getFullYear()} Paving Market</p>
  </div>
);

const Blobs = () => (<>
  <div style={{ position:"absolute", width:480, height:480, borderRadius:"50%", background:"#FEBA06", opacity:0.07, top:-160, right:-140, filter:"blur(85px)", pointerEvents:"none" }} />
  <div style={{ position:"absolute", width:360, height:360, borderRadius:"50%", background:"#FEBA06", opacity:0.05, bottom:-110, left:-110, filter:"blur(70px)", pointerEvents:"none" }} />
  <div style={{ position:"absolute", width:260, height:260, borderRadius:"50%", border:"1px solid rgba(255,255,255,0.04)", top:"8%", left:"4%", pointerEvents:"none" }} />
  <div style={{ position:"absolute", inset:0, backgroundImage:"radial-gradient(circle,rgba(255,255,255,0.022) 1px,transparent 1px)", backgroundSize:"36px 36px", pointerEvents:"none" }} />
</>);

const TopBar = ({ navigate, right }) => (
  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 28px", borderBottom:"1px solid #f3f4f6", flexShrink:0 }}>
    <button onClick={() => navigate("/")} style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", fontWeight:500, background:"none", border:"none", cursor:"pointer" }}>
      <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      Home Page
    </button>
    {right}
  </div>
);

const ResetPassword = ({ isModal = false, modalEmail, modalToken, onSwitch, onClose }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = isModal ? modalEmail : (searchParams.get("email") || "");
  const token = isModal ? modalToken : (searchParams.get("token") || "");

  const [form, setForm] = useState({ newPassword:"", confirmPassword:"" });
  const [fieldErrors, setFieldErrors] = useState({ newPassword:"", confirmPassword:"" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showCfm, setShowCfm] = useState(false);

  const ch = (e) => { 
    setForm(p => ({ ...p, [e.target.name]: e.target.value })); 
    setFieldErrors(p => ({ ...p, [e.target.name]: "" }));
    setError(""); 
  };

  const validate = () => {
    const errs = { newPassword: "", confirmPassword: "" };
    const pwd = form.newPassword;
    if (!pwd) errs.newPassword = "Password is required.";
    else if (pwd.length < 8) errs.newPassword = "Must be at least 8 characters.";
    else if (!/(?=.*[a-z])/.test(pwd)) errs.newPassword = "Must contain at least one lowercase letter.";
    else if (!/(?=.*[A-Z])/.test(pwd)) errs.newPassword = "Must contain at least one uppercase letter.";
    else if (!/(?=.*\d)/.test(pwd)) errs.newPassword = "Must contain at least one number.";
    else if (!/(?=.*[^a-zA-Z\d])/.test(pwd)) errs.newPassword = "Must contain at least one special character.";

    if (!form.confirmPassword) errs.confirmPassword = "Confirm password is required.";
    else if (pwd !== form.confirmPassword) errs.confirmPassword = "Passwords do not match.";

    setFieldErrors(errs);
    return !errs.newPassword && !errs.confirmPassword;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true); setError("");
    try {
      await resetPasswordService({ email, token, newPassword:form.newPassword, confirmPassword:form.confirmPassword });
      toast.success("Password reset successful!");
      if (isModal && onSwitch) {
        onSwitch("login");
      } else {
        navigate("/login");
      }
    } catch (err) { setError(err?.response?.data?.message || err?.message || "Reset failed."); }
    finally { setLoading(false); }
  };

  const toLogin = isModal && onSwitch ? (e) => { e.preventDefault(); onSwitch("login"); } : undefined;
  const toForgot = isModal && onSwitch ? (e) => { e.preventDefault(); onSwitch("forgot-password"); } : undefined;

  /* Invalid link */
  if (!token || !email) {
    return (
      <div style={bg}>
        <Blobs />
        <div style={cardStyle}>
          <LeftPanel navigate={navigate} />
          <div style={{ flex:1, background:"#ffffff", display:"flex", flexDirection:"column" }}>
            <TopBar navigate={navigate} right={
              <Link to="/forgot-password" style={{ fontSize:12, color:"#9ca3af", fontWeight:500, textDecoration:"none" }}>
                Need a new link?{" "}<span style={{ fontWeight:700, color:"#FEBA06" }}>Request one</span>
              </Link>
            } />
            <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px 28px" }}>
              <div style={{ width:"100%", maxWidth:300, textAlign:"center" }}>
                <div style={{ width:52, height:52, borderRadius:13, background:"#fef2f2", border:"2px solid #fecaca", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 18px" }}>
                  <svg width="24" height="24" fill="none" stroke="#f87171" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div style={{ fontSize:22, fontWeight:800, color:"#111827", marginBottom:8 }}>Invalid Link</div>
                <p style={{ fontSize:13, color:"#6b7280", marginBottom:24 }}>This reset link is invalid or has expired.</p>
                <Link to="/forgot-password" style={{ display:"block", width:"100%", background:"#FEBA06", color:"#111827", fontWeight:700, fontSize:14, padding:"13px 0", borderRadius:10, textDecoration:"none", letterSpacing:"0.03em", boxShadow:"0 6px 20px rgba(254,186,6,0.3)", textAlign:"center" }}>
                  Request a New Link
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isModal) return (
    <div style={{ background: "#ffffff", width: "100%" }}>
      {/* Dark header strip */}
      <div style={{ background: "#161412", padding: "16px 32px", display: "flex", alignItems: "center"}}>
        <img src={Logo} alt="Paving Market" style={{ height: 36, width: "auto" }} />
      </div>
      {/* Gold accent bar */}
      <div style={{ height: 3, background: "#FEBA06", width: "100%" }} />
      <div style={{ padding: "28px 32px 28px" }}>
        {(!token || !email) ? (
          <div style={{ textAlign:"center" }}>
            <div style={{ width:52, height:52, borderRadius:13, background:"#fef2f2", border:"2px solid #fecaca", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 18px" }}>
              <svg width="24" height="24" fill="none" stroke="#f87171" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div style={{ fontSize:20, fontWeight:800, color:"#161412", marginBottom:6 }}>Invalid Link</div>
            <p style={{ fontSize:13, color:"#6b7280", marginBottom:20 }}>This reset link is invalid or has expired.</p>
            <Link to="/forgot-password" onClick={toForgot} style={{ display:"block", width:"100%", background:"#FEBA06", color:"#161412", fontWeight:800, fontSize:13, padding:"13px 0", borderRadius:8, textDecoration:"none", letterSpacing:"0.06em", textTransform:"uppercase", fontFamily:"inherit" }}>
              Request a New Link
            </Link>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#161412", letterSpacing: "-0.02em" }}>Set New Password</div>
              <p style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
                For <span style={{ fontWeight: 700, color: "#FEBA06" }}>{email}</span>
              </p>
            </div>
            {error && (
              <div style={{ display:"flex", alignItems:"flex-start", gap:8, background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, padding:"9px 12px", marginBottom:16, fontSize:12, color:"#dc2626" }}>
                {error}
              </div>
            )}
            <form onSubmit={submit} noValidate style={{ display:"flex", flexDirection:"column", gap:16 }}>
              <div>
                <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#161412", letterSpacing:"0.08em", textTransform:"uppercase", marginBottom:7 }}>New Password</label>
                <div style={{ position:"relative" }}>
                  <input type={showNew?"text":"password"} name="newPassword" value={form.newPassword} onChange={ch} required autoComplete="new-password" placeholder="Create a strong password"
                    style={{ width:"100%", border:`1.5px solid ${fieldErrors.newPassword ? "#dc2626" : "#e5e7eb"}`, borderRadius:8, padding:"11px 40px 11px 14px", fontSize:13, color:"#161412", background: fieldErrors.newPassword ? "#fef2f2" : "#f9fafb", outline:"none", boxSizing:"border-box", fontFamily:"inherit" }}
                    onFocus={e=>{ e.target.style.borderColor= fieldErrors.newPassword ? "#dc2626" : "#FEBA06"; e.target.style.background="#fff"; }}
                    onBlur={e=>{ e.target.style.borderColor= fieldErrors.newPassword ? "#dc2626" : "#e5e7eb"; e.target.style.background= fieldErrors.newPassword ? "#fef2f2" : "#f9fafb"; }} />
                  <button type="button" onClick={()=>setShowNew(!showNew)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
                    <EyeIcon open={showNew} />
                  </button>
                </div>
                {fieldErrors.newPassword && <p style={{ margin:"5px 0 0", fontSize:11, color:"#dc2626", display:"flex", alignItems:"center", gap:4 }}>⚠ {fieldErrors.newPassword}</p>}
              </div>
              <div>
                <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#161412", letterSpacing:"0.08em", textTransform:"uppercase", marginBottom:7 }}>Confirm New Password</label>
                <div style={{ position:"relative" }}>
                  <input type={showCfm?"text":"password"} name="confirmPassword" value={form.confirmPassword} onChange={ch} required autoComplete="new-password" placeholder="Repeat your new password"
                    style={{ width:"100%", border:`1.5px solid ${fieldErrors.confirmPassword ? "#dc2626" : "#e5e7eb"}`, borderRadius:8, padding:"11px 40px 11px 14px", fontSize:13, color:"#161412", background: fieldErrors.confirmPassword ? "#fef2f2" : "#f9fafb", outline:"none", boxSizing:"border-box", fontFamily:"inherit" }}
                    onFocus={e=>{ e.target.style.borderColor= fieldErrors.confirmPassword ? "#dc2626" : "#FEBA06"; e.target.style.background="#fff"; }}
                    onBlur={e=>{ e.target.style.borderColor= fieldErrors.confirmPassword ? "#dc2626" : "#e5e7eb"; e.target.style.background= fieldErrors.confirmPassword ? "#fef2f2" : "#f9fafb"; }} />
                  <button type="button" onClick={()=>setShowCfm(!showCfm)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
                    <EyeIcon open={showCfm} />
                  </button>
                </div>
                {fieldErrors.confirmPassword && <p style={{ margin:"5px 0 0", fontSize:11, color:"#dc2626", display:"flex", alignItems:"center", gap:4 }}>⚠ {fieldErrors.confirmPassword}</p>}
              </div>
              <button type="submit" disabled={loading} style={{ width:"100%", background:"#FEBA06", color:"#161412", fontWeight:800, fontSize:13, padding:"13px 0", borderRadius:8, border:"none", cursor:"pointer", letterSpacing:"0.06em", textTransform:"uppercase", fontFamily:"inherit", opacity: loading ? 0.7 : 1, marginTop:4 }}>
                {loading ? <span style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}><Spinner />Resetting…</span> : "Reset Password"}
              </button>
            </form>
            <p style={{ textAlign:"center", marginTop:22, fontSize:13, color:"#6b7280" }}>
              Remember it?{" "}
              <Link to="/login" onClick={toLogin} style={{ color:"#161412", fontWeight:800, textDecoration:"none" }}>Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );

  return (
    <div style={bg}>
      <Blobs />
      <div style={cardStyle}>
        <LeftPanel navigate={navigate} />
        <div style={{ flex:1, background:"#ffffff", display:"flex", flexDirection:"column" }}>
          <TopBar navigate={navigate} right={
            <span style={{ fontSize:12, color:"#9ca3af", fontWeight:500 }}>
              Remember it?{" "}
              <Link to="/login" style={{ fontWeight:700, color:"#FEBA06", textDecoration:"none" }}>Sign in</Link>
            </span>
          } />

          <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px 28px" }}>
            <div style={{ width:"100%", maxWidth:320 }}>
              <div style={{ marginBottom:24 }}>
                <div style={{ fontSize:24, fontWeight:800, color:"#111827", letterSpacing:"-0.02em" }}>Set New Password</div>
                <p style={{ fontSize:13, color:"#6b7280", marginTop:5 }}>
                  For <span style={{ fontWeight:600, color:"#FEBA06" }}>{email}</span>
                </p>
              </div>

              {error && (
                <div style={{ display:"flex", alignItems:"flex-start", gap:10, background:"#fef2f2", border:"1px solid #fecaca", borderRadius:10, padding:"10px 14px", marginBottom:16, fontSize:13, color:"#dc2626" }}>
                  <svg style={{ width:14, height:14, marginTop:1, flexShrink:0 }} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {error}
                </div>
              )}

              <form onSubmit={submit} style={{ display:"flex", flexDirection:"column", gap:14 }}>
                <div>
                  <label style={{ display:"block", fontSize:13, fontWeight:600, color:"#111827", marginBottom:5 }}>New Password</label>
                  <div style={{ position:"relative" }}>
                    <input type={showNew?"text":"password"} name="newPassword" value={form.newPassword} onChange={ch}
                      required autoComplete="new-password" placeholder="Create a strong password"
                      style={{ ...inp, borderColor: fieldErrors.newPassword ? "#ef4444" : "#f3f4f6" }}
                      onFocus={e=>{e.target.style.borderColor=fieldErrors.newPassword?"#ef4444":"#FEBA06";e.target.style.background="#fff";}}
                      onBlur={e=>{e.target.style.borderColor=fieldErrors.newPassword?"#ef4444":"#f3f4f6";e.target.style.background="#f9fafb";}} />
                    <button type="button" onClick={()=>setShowNew(!showNew)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", color:"#d1d5db", background:"none", border:"none", cursor:"pointer" }}>
                      <EyeIcon open={showNew} />
                    </button>
                  </div>
                  {fieldErrors.newPassword && <p style={{ margin:"5px 0 0", fontSize:12, color:"#ef4444" }}>⚠ {fieldErrors.newPassword}</p>}
                </div>

                <div>
                  <label style={{ display:"block", fontSize:13, fontWeight:600, color:"#111827", marginBottom:5 }}>Confirm New Password</label>
                  <div style={{ position:"relative" }}>
                    <input type={showCfm?"text":"password"} name="confirmPassword" value={form.confirmPassword} onChange={ch}
                      required autoComplete="new-password" placeholder="Repeat your new password"
                      style={{ ...inp, borderColor: fieldErrors.confirmPassword ? "#ef4444" : "#f3f4f6" }}
                      onFocus={e=>{e.target.style.borderColor=fieldErrors.confirmPassword?"#ef4444":"#FEBA06";e.target.style.background="#fff";}}
                      onBlur={e=>{e.target.style.borderColor=fieldErrors.confirmPassword?"#ef4444":"#f3f4f6";e.target.style.background="#f9fafb";}} />
                    <button type="button" onClick={()=>setShowCfm(!showCfm)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", color:"#d1d5db", background:"none", border:"none", cursor:"pointer" }}>
                      <EyeIcon open={showCfm} />
                    </button>
                  </div>
                  {fieldErrors.confirmPassword && <p style={{ margin:"5px 0 0", fontSize:12, color:"#ef4444" }}>⚠ {fieldErrors.confirmPassword}</p>}
                </div>

                <button type="submit" disabled={loading} style={{ width:"100%", background:"#FEBA06", color:"#111827", fontWeight:700, fontSize:14, padding:"13px 0", borderRadius:10, border:"none", cursor:"pointer", letterSpacing:"0.03em", boxShadow:"0 6px 20px rgba(254,186,6,0.3)", marginTop:4, fontFamily:"inherit", opacity: loading ? 0.6 : 1 }}>
                  {loading ? <span style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}><Spinner />Resetting…</span> : "Reset Password"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
